import * as React from 'react';
import { Col, Grid, Row } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';

import { InlineGrid, InlineGridField } from '@components/form';

import { EventsFormPhotosForm } from '@modules/events/EventsFormPhotosForm';
import { photosGridColumns } from '@modules/events/_eventsColumns';
import { ModalButton } from '@components/modalButton/ModalButton';
import { EventsFormPhotosMultipleUploader } from '@modules/events/EventsFormPhotosMultipleUploader';
import { compose, lifecycle, withProps } from 'recompose';

const enhance = compose<any, any>(
  lifecycle<any, {}, {}>({
    componentWillUnmount() {
      localStorage.removeItem('photos');
    },
    componentWillMount() {
      localStorage.removeItem('photos');
    }
  })
);

const View: React.SFC<any> = ({ disabled, setDisableSps }) => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col md={12}>
          <h4>Fotodokumentace</h4>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <InlineGridField
            component={InlineGrid}
            name="eventPhotos"
            Form={withProps({ setDisableSps })(EventsFormPhotosForm)}
            ActionBar={() => (
              <div className="buttons">
                <ModalButton
                  label={'Přidat hromadně'}
                  style={{ marginLeft: 10 }}
                  disabled={disabled}
                  ModalComponent={withProps({ setDisableSps })(EventsFormPhotosMultipleUploader)}
                />
              </div>
            )}
            columns={photosGridColumns}
            showCheckboxes={true}
            adding={!disabled}
            editing={!disabled}
            deleting={!disabled}
            onDelete={() => setDisableSps(true)}
          />
        </Col>
      </Row>
    </Grid>

    <Divider />
  </div>
);

export default enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormPhotos.tsx